import { render } from "./PackageCreate.vue?vue&type=template&id=631684ea&scoped=true"
import script from "./PackageCreate.vue?vue&type=script&lang=js"
export * from "./PackageCreate.vue?vue&type=script&lang=js"

import "./PackageCreate.vue?vue&type=style&index=0&id=631684ea&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631684ea"]])

export default __exports__